(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('recipe-recs');
    if (!el || !el.dataset.recsUrl) return;
    fetch(el.dataset.recsUrl)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject();
      })
      .then(function (html) {
        var recs = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.recipe-recs');
        if (recs) el.replaceWith(recs);
      })
      .catch(function () {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-workshops"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wks').forEach(function (wks) {
    var chips = wks.querySelectorAll('[data-sede]');
    var rows = wks.querySelectorAll('.wk[data-venue]');
    var empty = wks.querySelector('.wks__filter-empty');
    if (chips.length < 2) return;

    function apply(sede) {
      var shown = 0;
      rows.forEach(function (row) {
        var match = !sede || row.getAttribute('data-venue') === sede;
        row.hidden = !match;
        if (match) shown += 1;
      });
      chips.forEach(function (chip) {
        chip.classList.toggle('wks__chip--active', chip.getAttribute('data-sede') === sede);
      });
      if (empty) empty.hidden = shown !== 0;

      var url = new URL(window.location);
      if (sede) {
        url.searchParams.set('sede', sede);
      } else {
        url.searchParams.delete('sede');
      }
      window.history.replaceState({}, '', url);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-sede'));
      });
    });

    // Honour a shared ?sede= link on load, if it matches a chip.
    var initial = new URL(window.location).searchParams.get('sede') || '';
    var known = false;
    chips.forEach(function (chip) {
      if (chip.getAttribute('data-sede') === initial) known = true;
    });
    apply(known ? initial : '');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.ga-search[data-predictive-url]');
    if (!form) return;

    var input = form.querySelector('[data-search-input]');
    var results = form.querySelector('[data-search-results]');
    var url = form.getAttribute('data-predictive-url');
    var timer;
    var controller;

    function hide() {
      results.hidden = true;
      results.innerHTML = '';
    }

    function run() {
      var q = input.value.trim();
      if (controller) controller.abort();
      if (q.length < 2) { hide(); return; }

      controller = new AbortController();
      var endpoint = url + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,article,query' +
        '&resources[limit]=6';

      fetch(endpoint, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (q !== input.value.trim()) return;
          results.innerHTML = html;
          results.hidden = false;
        })
        .catch(function () { /* aborted or offline: keep prior results */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 200);
    });
    input.addEventListener('focus', function () {
      if (results.innerHTML.trim()) results.hidden = false;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); input.blur(); }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero').forEach(function (hero) {
    var copies = hero.querySelectorAll('[data-slide-copy]');
    var medias = hero.querySelectorAll('[data-slide-media]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var count = medias.length;
    if (count < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function show(n) {
      current = (n + count) % count;
      [copies, medias].forEach(function (set) {
        set.forEach(function (el, i) {
          el.classList.toggle('is-active', i === current);
        });
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (reduce) return;
      stop();
      timer = setInterval(function () {
        show(current + 1);
      }, 6000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);

    // Swipe on the split only, so the scrolling category strip below keeps its own gesture.
    var split = hero.querySelector('.hero__split');
    var startX = null;
    if (split) {
      split.addEventListener('pointerdown', function (e) {
        startX = e.clientX;
      });
      split.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) {
          show(dx < 0 ? current + 1 : current - 1);
          start();
        }
      });
    }

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-workshop"] && !Shopify.designMode) return;
  try {
    
  // Picking a session swaps the price, the button and the status pill. Every
  // string comes from a data attribute because this block renders no Liquid,
  // so it cannot format money. Without JS the radio still posts the right
  // variant id; only the surrounding copy stays on the default session.
  (function () {
    var radios = document.querySelectorAll('input[data-session]')
    if (!radios.length) return

    var prices = document.querySelectorAll('[data-session-price]')
    var ctas = document.querySelectorAll('[data-session-cta]')
    var compare = document.querySelector('[data-session-compare]')
    var off = document.querySelector('[data-session-off]')
    var status = document.querySelector('[data-session-status]')
    var venue = document.querySelector('[data-session-venue]')
    var line = document.querySelector('[data-session-line]')
    var qty = document.querySelector('[data-qty] input')
    var qtyWrap = document.querySelector('[data-qty]')
    var submitLabel = qtyWrap ? qtyWrap.dataset.submitLabel : ''
    var moneyPrefix = qtyWrap ? qtyWrap.dataset.moneyPrefix : ''

    function total(radio) {
      var n = (parseInt(qty && qty.value, 10) || 1) * parseInt(radio.dataset.cents, 10) / 100
      return submitLabel + ' · ' + moneyPrefix + n.toLocaleString('es-MX', { maximumFractionDigits: 2 })
    }

    function sync(radio) {
      prices.forEach(function (price) {
        price.textContent = radio.dataset.price
        price.classList.toggle('wshop__price-amount--sale', !!radio.dataset.compare)
      })
      ctas.forEach(function (cta) {
        cta.textContent = radio.dataset.available === 'true' ? total(radio) : radio.dataset.cta
        cta.disabled = radio.dataset.available !== 'true'
      })
      if (compare) {
        compare.textContent = radio.dataset.compare || ''
        compare.hidden = !radio.dataset.compare
      }
      if (off) {
        off.textContent = radio.dataset.off ? '−' + radio.dataset.off + '%' : ''
        off.hidden = !radio.dataset.off
      }
      if (status) {
        var text = radio.dataset.statusText
        var mod = radio.dataset.statusMod
        status.textContent = text
        status.className = 'wshop__status' + (mod ? ' wshop__status--' + mod : '')
        status.hidden = !text
      }
      // A workshop can run in more than one venue, so the eyebrow and the
      // "Sede y horario" line describe the chosen session, not the product.
      if (venue) {
        venue.textContent = radio.dataset.venue ? ' · ' + radio.dataset.venue : ''
        venue.hidden = !radio.dataset.venue
      }
      if (line) {
        line.textContent = radio.dataset.line
        line.hidden = !radio.dataset.line
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) sync(radio)
      })
    })
    if (qty) qty.addEventListener('change', function () {
      radios.forEach(function (radio) {
        if (radio.checked) sync(radio)
      })
    })
  })();

  // Gallery: a thumbnail shows its media item (image or video). No-JS shows the first image and
  // the thumbnails still link nowhere harmful (plain buttons).
  (function () {
    var items = document.querySelectorAll('[data-gallery-item]');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!items.length || !thumbs.length) return;
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        items.forEach(function (item, j) {
          item.hidden = i !== j;
          var video = item.querySelector('video');
          if (video && i !== j) video.pause();
        });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  })();

  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-down]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    wrap.querySelector('[data-qty-up]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Selecting a variant swaps the price, the add button (label + disabled) and
  // the stage image in place. Every formatted string comes from a data
  // attribute because this block renders no Liquid and cannot format money.
  // Without JS the <select> still posts the chosen variant id; only the
  // surrounding copy stays on the default variant.
  (function () {
    var select = document.querySelector('.pdp__select')
    if (!select) return

    var price = document.querySelector('[data-variant-price]')
    var compare = document.querySelector('[data-variant-compare]')
    var discount = document.querySelector('[data-variant-discount]')
    var add = document.querySelector('[data-variant-add]')
    var offer = document.querySelector('[data-variant-offer]')
    var addMobile = add ? add.querySelector('.pdp__add-mobile') : null
    var track = document.querySelector('[data-track]')

    function sync() {
      var opt = select.options[select.selectedIndex]
      if (!opt) return
      if (price) price.textContent = opt.dataset.price
      var onSale = !!opt.dataset.compare
      if (price) price.classList.toggle('pdp__price--sale', onSale)
      if (compare) {
        compare.textContent = onSale ? opt.dataset.compare : ''
        compare.hidden = !onSale
      }
      if (discount) {
        discount.textContent = onSale ? opt.dataset.discount : ''
        discount.hidden = !onSale
      }
      // A disabled input is not submitted, so a full-price variant adds no
      // Oferta property at all.
      if (offer) {
        offer.value = opt.dataset.offer || ''
        offer.disabled = !opt.dataset.offer
      }
      if (add) {
        var available = opt.dataset.available === 'true'
        add.disabled = !available
        if (addMobile) {
          addMobile.textContent = available
            ? add.dataset.addLabel + ' · ' + opt.dataset.priceShort
            : add.dataset.soldOutLabel
        }
      }
      // Scroll to the variant's own image, matched by URL: the slide and the
      // option are both rendered at width 1000, so the same image is the same
      // CDN URL. A variant with no media of its own leaves the track alone.
      if (track && opt.dataset.image) {
        var slides = track.children
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.full === opt.dataset.image) {
            track.scrollLeft = i * track.clientWidth
            break
          }
        }
      }
    }

    select.addEventListener('change', sync)
    // Re-sync when the browser restores a changed selection (reload/bfcache),
    // otherwise the price/label would revert to the server-rendered default.
    window.addEventListener('pageshow', sync)
  })();

  // The stage scrolls natively (swipe on mobile); this only keeps the
  // thumbnails and dots pointing at whatever slide the scroll landed on.
  (function () {
    var track = document.querySelector('[data-track]')
    if (!track) return
    var thumbs = document.querySelectorAll('[data-thumb]')
    var dots = document.querySelectorAll('.pdp__dot')

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })
      })
    })

    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth)
      thumbs.forEach(function (t, j) { t.classList.toggle('pdp__thumb--active', j === i) })
      dots.forEach(function (d, j) { d.classList.toggle('pdp__dot--active', j === i) })
    })
  })();

  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-down]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    wrap.querySelector('[data-qty-up]').addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
